<template>
  <div class="home">
    <div class="line"></div>
    <el-tabs tab-position="left">
      <el-tab-pane label="用户管理">
        <p>当前用户等级： 注册会员</p>
      </el-tab-pane>
      <el-tab-pane label="基本配置">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="我的资料" name="fast">
            <el-form
              abel-position="left"
              label-width="80px"
              :model="ruleForm"
              ref="ruleForm"
              :rules="rules"
            >
              <el-form-item label="邮箱" prop="email">
                <el-input
                  v-model="ruleForm.email"
                  autocomplete="off"
                  placeholder="请输入邮箱"
                ></el-input>
              </el-form-item>
              <el-form-item label="电话" prop="phone">
                <el-input
                  v-model="ruleForm.phone"
                  maxlength="11"
                  autocomplete="off"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
              <el-form-item class="btn-footer">
                <el-button type="primary" @click="submitForm('ruleForm')"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="修改密码" name="second">
            <div>
              <el-form
                abel-position="left"
                label-width="80px"
                :model="changForm"
                ref="changForm"
                :rules="rules"
              >
                <el-form-item
                  label="密码"
                  prop="changepassword"
                  label-width="100px"
                >
                  <el-input
                    v-model="changForm.changepassword"
                    placeholder="输入密码:"
                    autocomplete="off"
                    type="password"
                    show-password
                  ></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password" label-width="100px">
                  <el-input
                    v-model="changForm.password"
                    placeholder="输入密码:"
                    autocomplete="off"
                    type="password"
                    show-password
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="确认密码"
                  prop="checkPass"
                  label-width="100px"
                >
                  <el-input
                    type="password"
                    v-model="changForm.checkPass"
                    placeholder="再次确认密码:"
                    show-password
                  ></el-input>
                </el-form-item>
                <el-form-item class="btn-footer">
                  <el-button
                    type="primary"
                    @click="changesubmitForm('changForm')"
                    >提交</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <el-tab-pane label="发布内容" label-width="100px">
        <div>
          <el-form
            :model="formPublish"
            :rules="rules"
            ref="formPublish"
            label-width="100px"
          >
            <el-form-item label="分类:" prop="fication" label-width="100px">
              <el-cascader
                style="position: absolute; left: 5px; top: 5px"
                v-model="formPublish.fication"
                :options="options"
                @change="handleChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="标题:" prop="title">
              <el-input v-model="formPublish.title"></el-input>
            </el-form-item>
            <el-form-item label="发布人:" prop="publi">
              <el-input v-model="formPublish.publi"></el-input>
            </el-form-item>
            <el-form-item label="联系电话:" prop="tphonen">
              <el-input v-model="formPublish.tphonen"></el-input>
            </el-form-item>
            <el-form-item label="所在地:" prop="address">
              <el-input v-model="formPublish.address"></el-input>
            </el-form-item>
            <el-form-item label="图片：">
              <div
                class="picture"
                style="display: flex; justify-content: space-around"
              >
                <el-image
                  style="
                    width: 120px;
                    height: 120px;
                    border: 1px solid #ccc;
                    margin-left: 10px;
                  "
                  :src="base64"
                ></el-image>
                <div
                  style="flex: 1; position: relative; border: 1px solid #ccc"
                >
                  <input
                    style="width: 100%; height: 100%; vertical-align: middle"
                    type="file"
                    ref="file"
                    @change="showimg"
                  />
                  <i
                    style="
                      position: absolute;
                      top: 20%;
                      left: 20%;
                      transform: translate(-50%, -50%);
                      font-size: 30px;
                    "
                    id="changes"
                    @click="changeimg"
                  ></i>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="发布内容:" prop="connet">
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="formPublish.connet"
                maxlength="500"
                show-word-limit
              ></el-input>
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  color: red;
                "
              >
                用户发布内容2元一条
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm2('formPublish')"
                >提交</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="我的投稿">
        <div>
          <h3>我的投稿</h3>
          <el-table :data="tableList">
            <el-table-column prop="id" label="ID" width="180">
            </el-table-column>
            <el-table-column prop="title" label="标题" width="180">
            </el-table-column>
            <el-table-column prop="con" label="内容" width="180">
            </el-table-column>
            <el-table-column prop="sta_txt" label="状态" width="180">
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  @click="handleClickDele(scope.row.id)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="在线充值">
        <el-tabs v-model="active">
          <el-tab-pane label="充值支付" name="one">
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: flex-start;
              "
            >
              <div style="margin-bottom: 10px">当前账户：6676666611@qq.com</div>
              <div style="margin-bottom: 10px">
                账户余额：
                <span style="font-size: larger; color: red">¥0.00</span>
              </div>
              <div
                style="display: flex; align-items: center; margin-bottom: 10px"
              >
                <span>充值金额：</span>
                <el-input
                  v-model="value"
                  placeholder="请输入充值金额"
                  style="width: 200px"
                ></el-input>
                <span>元</span>
              </div>
              <div style="margin-bottom: 10px">
                <span>支付方式：</span>
                <img
                  src="../assets//zhi.png"
                  alt="支付方式"
                  style="width: 96px"
                />
              </div>
              <div>
                <el-button type="primary" @click="submitChange()"
                  >提交</el-button
                >
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="支付" :visible.sync="dialogVisible" width="30%" center>
      <el-image :src="src"></el-image>
      <!-- <img src="../assets/fu.jpeg" alt="支付方式" style="width: 96px" /> -->
      <span slot="footer" class="dialog-footer">
        <div>
          <span>支付方式：</span>
          <span>
            <img src="../assets//zhi.png" alt="支付方式" style="width: 96px"
          /></span>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import axios from 'axios';
import base64toFile from './base';
export default {
  name: 'Home',
  components: {},
  data() {
    // 手机验证
    var checkMobile = (rules, value, cb) => {
      const regMobile =
        /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/;

      if (regMobile.test(value)) {
        return cb();
      }

      cb(new Error('请输入合法的手机号'));
    };
    // 邮箱验证
    var checkEmail = (rule, value, cb) => {
      //验证邮箱的正则表达式
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if (regEmail.test(value)) {
        return cb();
      }
      cb(new Error('请输入合法的邮箱'));
    };
    // 再次确认密码
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.changForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      activeName: 'fast',
      active: 'one',
      value: '',
      // 我的资料
      ruleForm: {
        email: '',
        phone: '',
      },
      checked: null,
      shake: false,
      rules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur', min: 9, max: 18 },
        ],
        phone: [
          {
            message: '请输入手机号',
            trigger: 'blur',
            min: 11,
            max: 11,
          },
          { validator: checkMobile, trigger: 'blur' },
        ],
        changepassword: [{ required: true, trigger: 'blur' }],
        password: [{ validator: validatePass2, trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }],
        tphonen: [
          {
            message: '请输入手机号',
            trigger: 'blur',
            min: 11,
            max: 11,
          },
          { validator: checkMobile, trigger: 'blur' },
        ],
      },
      changForm: {
        password: '',
        checkPass: '',
        changepassword: '',
      },
      formPublish: {
        fication: '', //分类
        title: '', //标题
        publi: '', //发布人
        tphonen: '', //联系电话
        address: '', //所在地
        picture: '', //图片
        connet: '', //产品内容,
      },
      options: [
        {
          value: '1',
          label: '共享产品',
          children: [
            {
              value: '5',
              label: '共享陪护椅',
            },
          ],
        },
        {
          value: '2',
          label: '平台建设',
          children: [
            {
              value: '8',
              label: 'IOT平台',
            },
          ],
        },
        // {
        //   value: '3',
        //   label: '硬件开发',
        //   children: [
        //     {
        //       value: '9',
        //       label: '秒道通讯模块',
        //     },
        //   ],
        // },
        {
          value: '4',
          label: '工厂OEM',
          children: [
            {
              value: '10',
              label: '共享陪护椅改造套件',
            },
          ],
        },
      ],
      fileList: [],
      tableList: [],
      base64: '',
      dialogVisible: false,
      src: 'https://miaodaokeji.com/wb/zfb.png',
    };
  },
  created() {
    this.httpList();
  },
  methods: {
    // 我的资料提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // const url = 'https://miaodaokeji.com/wb/index.php/Newicp/upinfo';
          const payload = {
            phone: this.ruleForm.phone,
            email: this.ruleForm.email,
          };
          // axios
          //   .post(url, payload, {
          //     headers: {
          //       'Content-Type': 'multipart/form-data',
          //       'Access-Control-Allow-Origin': '*',
          //     },
          //   })
          this.$axios
            .post('wb/index.php/Newicp/upinfo', payload, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*',
              },
              withCredentials: true,
            })
            .then((res) => {
              if (res.data.status === 2000) {
                this.$message({
                  message: '请先登陆',
                  type: 'warning',
                });
                this.$router.push('/login');
              } else if (res.data.status === 1) {
                this.$message({
                  message: '修改成功',
                  type: 'success',
                });
                (this.ruleForm.phone = ''), (this.ruleForm.email = '');
              } else {
                this.$message({
                  message: res.data.info,
                  type: 'warning',
                });
                (this.ruleForm.phone = ''), (this.ruleForm.email = '');
              }
            })
            .catch((error) => {
              console.log(error);
              // this.$message({
              //   message: '发布信息失败，请重试',
              //   type: 'warning',
              // });
              (this.ruleForm.phone = ''), (this.ruleForm.email = '');
            });
        } else {
          console.log('error submit!!');
        }
      });
    },
    // 修改密码
    changesubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // const url = 'https://miaodaokeji.com/wb/index.php/Newicp/upinfo_pwd';
          const payload = {
            pwd: this.changForm.password,
            npwd: this.changForm.checkPass,
            cpwd: this.changForm.changepassword,
          };
          this.$axios
            .post('wb/index.php/Newicp/upinfo_pwd', payload, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*',
              },
              withCredentials: true,
            })
            .then((res) => {
              if (res.data.status === 2000) {
                this.$message({
                  message: '请先登陆',
                  type: 'warning',
                });
                this.$router.push('/login');
              } else if (res.data.status === 1) {
                this.$message({
                  message: '修改成功',
                  type: 'success',
                });
                (this.changForm.password = ''), (this.ruleForm.email = '');
              } else {
                this.$message({
                  message: res.data.info,
                  type: 'warning',
                });
                (this.ruleForm.phone = ''),
                  (this.changForm.checkPass = ''),
                  (this.changForm.changepassword = '');
              }
            })
            .catch((error) => {
              console.log(error);
              (this.ruleForm.phone = ''),
                (this.changForm.checkPass = ''),
                (this.changForm.changepassword = '');
            });
        } else {
          console.log('error submit!!');
        }
      });
    },
    // 发布内容布
    handleChange(value) {
      console.log(value);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },

    uset() {
      (this.formPublish.title = ''),
        (this.formPublish.publi = ''),
        (this.formPublish.tphonen = ''),
        (this.formPublish.address = ''),
        (this.formPublish.connet = ''),
        (this.formPublish.picture = ''),
        (this.formPublish.fication = '');
      this.base64 = '';
    },

    // 预览图片
    showimg() {
      const that = this;
      // 读取文件内容
      var fr = new FileReader();
      // 将读取到的文件编码成DataURL
      fr.readAsDataURL(that.$refs.file.files[0]);
      // 文件读取成功时触发
      fr.onload = function () {
        const base64 = fr.result;
        this.base64 = base64;
        // 将 Base64 格式的字符串转换成 File 对象
        const blob = base64toFile(base64, 'file');
        // const file = new File([blob], 'image.png', { type: 'image/png' });
        console.log(blob, 'blob');
        that.formPublish.picture = blob;
      };
    },
    submitChange() {
      console.log(111);
      this.dialogVisible = true;
    },

    // 更换图片
    changeimg() {
      // 给元素添加自定义事件
      this.$refs.file.dispatchEvent(new MouseEvent('click'));
    },

    submitForm2(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // const url = 'https://miaodaokeji.com/wb/index.php/Newicp/product_add';
          const payload = {
            title: this.formPublish.title,
            peo: this.formPublish.publi,
            phone: this.formPublish.tphonen,
            addres: this.formPublish.address,
            con: this.formPublish.connet,
            mdf: this.formPublish.picture,
            cate_id: this.formPublish.fication[0],
            sub_id: this.formPublish.fication[1],
          };
          this.$axios
            .post('wb/index.php/Newicp/product_add', payload, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*',
              },
              withCredentials: true,
            })
            .then((res) => {
              if (res.data.status === 2000) {
                this.$message({
                  message: '请先登陆',
                  type: 'warning',
                });
                this.$router.push('/login');
              } else if (res.data.status === 1) {
                this.$message({
                  message: '发布成功',
                  type: 'success',
                });
                this.$router.push('/PublicProducts');
                this.uset();
              } else {
                this.$message({
                  message: res.data.info,
                  type: 'warning',
                });
                this.uset();
              }
            })
            .catch((error) => {
              console.log(error);
              // this.$message({
              //   message: '发布信息失败，请重试',
              //   type: 'warning',
              // });
              // this.uset();
            });
        } else {
          console.log('error submit!!');
        }
      });
    },
    // 我的投稿
    httpList() {
      // const url = 'https://miaodaokeji.com/wb/index.php/Newicp/product_list';
      const payload = {
        act: '1',
      };
      this.$axios
        .post('wb/index.php/Newicp/product_list', payload, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*',
          },
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.status === 2000) {
            this.$message({
              message: '请先登陆',
              type: 'warning',
            });
            this.$router.push('/login');
          } else if (res.data.status === 1) {
            this.tableList = res.data.info;
          } else {
            this.$message({
              message: res.data.info,
              type: 'warning',
            });
            this.uset();
          }
        })
        .catch((error) => {
          console.log(error);
          // this.$message({
          //   message: '发布信息失败，请重试',
          //   type: 'warning',
          // });
          // this.uset();
        });
    },
    // 删除
    handleClickDele(row) {
      const payload = {
        id: row,
      };
      this.$axios
        .post('wb/index.php/Newicp/product_del', payload, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*',
          },
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.status === 2000) {
            this.$router.push('/login');
            this.$message({
              message: '请先登陆',
              type: 'warning',
            });
          } else if (res.data.status === 1) {
            this.$message({
              message: '删除成功！',
              type: 'success',
            });
            this.httpList();
          } else {
            this.$message({
              message: res.data.info,
              type: 'warning',
            });
            this.uset();
          }
        })
        .catch((error) => {
          console.log(error);
          // this.$message({
          //   message: '发布信息失败，请重试',
          //   type: 'warning',
          // });
          // this.uset();
        });
    },
  },
};
</script>

<style>
.home {
  margin: 5px 20px;
  padding-top: 100px;
}
h3,
h2 {
  text-align: left;
}
.line {
  width: 90%;
  height: 1px;
  background: black;
}
.home p {
  text-align: left;
}
</style>
